<template>
  <div class="axis-rectify-page">
    <iframe
        ref="frame"
        src="/axis-rectify.html"
        class="axis-rectify-frame"
        frameborder="0"
        scrolling="no"></iframe>
  </div>
</template>

<script>
export default {
  name: 'ToolAxisRectify',
  methods: {
    onMessage (e) {
      if (e.data && e.data.type === 'axis-rectify-height') {
        const iframe = this.$refs.frame;
        if (iframe) {
          iframe.style.height = e.data.height + 'px';
        }
      }
    }
  },
  mounted () {
    window.addEventListener('message', this.onMessage);
  },
  beforeDestroy () {
    window.removeEventListener('message', this.onMessage);
  }
}
</script>

<style scoped>
.axis-rectify-page {
  width: 100%;
  min-height: calc(100vh - 80px);
  background: #f2f3f5;
}
.axis-rectify-frame {
  width: 100%;
  border: 0;
  display: block;
}
</style>
